
import './scss/style.scss'
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { Routes, Route } from "react-router-dom";
import {Cart} from "./pages/Cart";
import CartProvider from "./states/CartProvider"
import OrderProvider from "./states/OrderProvider";
import {useEffect, useState} from "react";


//ToDo:  Создать базу данных товаров на AirTable и через Api выгрузить на сайт
//ToDo:  1. Сделать загрузку товаров
// 2. Загрузить товары для магазина Аркадии
// 3. Добавить в Футор информацию
// 4. Добавить фунуционал добавления в корзину типа и размера товаров
//FixMe: 1. Исправить категории товаров
// 2. Перевести на английский
// 3. Clean code






function App() {
    const [state, setState] = useState(null);
    const callBackendAPI = async () => {
        const response = await fetch('/express_backend');
        const body = await response.json();

        if (response.status !== 200) {
            throw Error(body.message)
        }
        return body;
    };

    useEffect(() => {
        callBackendAPI()
            .then(res => setState(res.express))
            .catch(err => console.log(err));
    }, []);
  return(
      <div className="wrapper">

      <CartProvider>
      <OrderProvider>
      <Header/>

        <div className='container'>
            <Routes>
                <Route path="/"  element={<App/>} />
                <Route path="/cart"  element={<Cart/>} />
                <Route index element={<Home/>} />
                <Route path="*" element={<NotFound/>} />
            </Routes>


        </div>
        </OrderProvider>
        </CartProvider>

          <Footer/>

      </div>
  );
}

export default App;
